import { render, staticRenderFns } from "./PresentacionesListAdmin.vue?vue&type=template&id=7fb02304&scoped=true&"
import script from "./PresentacionesListAdmin.vue?vue&type=script&lang=js&"
export * from "./PresentacionesListAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PresentacionesListAdmin.vue?vue&type=style&index=0&id=7fb02304&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb02304",
  null
  
)

export default component.exports